import { useMemo } from "react";
import { validator } from "@/utils/validator";

export const useShareUrlSchema = () => {
  const shareUrlSchema = useMemo(() => {
    return validator.object().shape({
      link: validator.string().label("共有URL"),
      password: validator.string().label("閲覧パスワード").max(64),
    });
  }, []);
  return {
    shareUrlSchema,
  };
};
